import { Directive, EventEmitter, HostListener, Inject, Output
       } from '@angular/core';
import { MatDialog } from '@angular/material';

import { ProgressType
       } from 'app/controls/progress-overlay/progress-overlay.component';
import { Button } from 'app/dialogs/dialog-buttons.component';
import { ErrorDialogComponent
       } from 'app/dialogs/error-dialog/error-dialog.component';
import { ProductDesignerService } from 'app/product-designer.service';
import { ConfigService } from 'core/config/config.service';
import { TrivialError } from 'core/error/error';
import { ProductService } from 'core/product/product.service';
import { BuildPostDataError, ProductdesignerdService
       } from 'core/productdesignerd/productdesignerd.service';
import { ProgressService } from './progress.service';

import { EventTrackingService, TrackingObject
       } from 'core/tracking/event-tracking.service';

class UploadProductError extends TrivialError
{
  // i18n.error.uploadProductError.title
  // i18n.error.uploadProductError.message
  protected _name: string = 'UploadProductError';
}

class MalformedProductError extends TrivialError
{
  // i18n.error.malformedProductError.title
  // i18n.error.malformedProductError.message
  protected _name: string = 'MalformedProductError';
}

@Directive({
  selector: '[finalize-design]'
})
export class FinalizeDesignDirective
{
  @Output() public finalizedDesign: EventEmitter<string> = new EventEmitter();

  private errorsOccurred: Array<String> = [];

  constructor(
    private dialog: MatDialog,
    @Inject(ProductService) private productService: ProductService,
    @Inject(ProductdesignerdService) private productdesignerdService:
        ProductdesignerdService,
    @Inject(ConfigService) private configService: ConfigService,
    @Inject(EventTrackingService) private eventTrackingService:
        EventTrackingService,
    @Inject(ProgressService) private progressService: ProgressService,
    @Inject(ProductDesignerService) private productDesignerService:
        ProductDesignerService
  )
  { }

  @HostListener('validationDone', ['$event'])
  public async finalizeDesign(event): Promise<void>
  {
    this.productDesignerService.suspendDesignerTrigger.emit(
      {suspend: true, progressType: ProgressType.Final});

    const trackEvent = () => {
      let trackingObject = <TrackingObject> {
        category: this.productService.getCurrentProduct().id,
        action: 'progress_finalization',
      };
      if (this.errorsOccurred.length > 0) {
        trackingObject.label = this.errorsOccurred.join('|');
        this.errorsOccurred = [];
      }
      this.eventTrackingService.track(trackingObject);
    };

    await this.progressService.commitChanges();

    this.productdesignerdService.postProducts(
        this.configService.getProductDesignerComponentConfig(),
        this.productService.getCurrentProduct())
      .then((response) => {
        trackEvent();
        this.finalizedDesign.emit(response);
      })
      .catch((error) => {
        const isClientError = error && (
            error instanceof BuildPostDataError ||
            (error.status > 399 && error.status < 500));

        this.productDesignerService.suspendDesignerTrigger.emit(
          {suspend: false, progressType: ProgressType.Default});

        this.errorsOccurred.push(
            (error.error && error.error.title) ? error.error.title : error);
        this.dialog.open(ErrorDialogComponent, {
          data: {
            errors: [ isClientError ? new MalformedProductError(error) :
                                      new UploadProductError(error) ],
            buttons: isClientError ? {} :
                                     {
                                        primary: Button.RETRY,
                                        secondary: Button.CANCEL
                                     }
          },
          panelClass: 'dialog-pane',
          disableClose: isClientError,
        }).afterClosed().subscribe(result => {
          if (result === Button.Choice.RETRY) {
            this.finalizeDesign(undefined);
          }
          else {
            trackEvent();
            this.finalizedDesign.emit();
          }
        });
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/progress/finalize-design.directive.ts